var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetinZerinde(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Metin-\xDCzerinde") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementler-KIT",
    transform: "translate(-830.000000, -2496.000000)",
    fill: "#464646"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Metin-\\xDCzerinde",
    transform: "translate(830.000000, 2496.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21,0 C21.5522847,-1.01453063e-16 22,0.44771525 22,1 L22,21 C22,21.5522847 21.5522847,22 21,22 L1,22 C0.44771525,22 6.76353751e-17,21.5522847 0,21 L0,1 C-6.76353751e-17,0.44771525 0.44771525,1.01453063e-16 1,0 L21,0 Z M15.6863905,11.8461538 L5.92307692,11.8461538 L5.92307692,13.5384615 L15.6863905,13.5384615 L15.6863905,11.8461538 Z M19.4615385,9.30769231 L2.53846154,9.30769231 L2.53846154,11 L19.4615385,11 L19.4615385,9.30769231 Z",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetinZerinde);
export default __webpack_public_path__ + "static/media/Metin-Üzerinde.afdd24457e94bba2c9ea1d67b2712ca5.svg";
export { ForwardRef as ReactComponent };